import React from 'react';

export default class ElegantResumePersonalInformation extends React.Component {
    render() { 
        return <div data-v-5a80631c="" className="section-left">
                { this.props.data.name && <div data-v-5a80631c="" className="section-name">{this.props.data.name}</div>}
                { this.props.data.profession && <div data-v-5a80631c="" className="section-title section-title__pro">{this.props.data.profession}</div>}
				{ this.props.data.website && <div data-v-5a80631c="" className="section-contact">{this.props.data.website}</div>}
				{ this.props.data.email && <div data-v-5a80631c="" className="section-contact">{ this.props.data.email }</div>}
				{ this.props.data.phone && <div data-v-5a80631c="" className="section-contact">{ this.props.data.phone }</div>}
				{ this.props.data.address && <div data-v-5a80631c="" className="section-contact section-contact__address">{this.props.data.address}</div>}
            </div>
    }
}